import firebase from 'firebase';
import 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyC3LtCtG9zLypw89UKg3zA2AOjeT3klFTc',
  authDomain: 'edogawa-music-web.firebaseapp.com',
  databaseURL: 'https://edogawa-music-web.firebaseio.com',
  projectId: 'edogawa-music-web',
  storageBucket: 'edogawa-music-web.appspot.com',
  messagingSenderId: '1009511494856',
  appId: '1:1009511494856:web:e90f97b2154be75d31a1fd',
};

firebase.initializeApp(firebaseConfig);

export const firestore = firebase.firestore();
export const auth = firebase.auth;
export const storage = firebase.storage;
